import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';

import './FeaturedArticle.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Article } from '../../types/shared/Article';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Image, TextLine, Button } from '../../importCL';

interface IFeaturedArticleProps extends MappedComponentProperties {
    newsVariant?: boolean;
    hideImage?: boolean;
    articlePath?: string;
    article?: Article;
    ctaText?: string;
    ctaLink?: string;
    ctaButton?: boolean;
    hideBottomBorder?: boolean;
    bgIsWhite?: boolean;
}

export const FeaturedArticleEditConfig = {
    emptyLabel: 'Featured Article',
    isEmpty: (props: PropsWithChildren<IFeaturedArticleProps>) => {
        return !props || !props.articlePath;
    },
};

const FeaturedArticle = (props: PropsWithChildren<IFeaturedArticleProps>): JSX.Element | null => {
    const articleFeedData: { currentPageNumber?: number } = JSON.parse(
        PathUtils.getMetaPropertyValue('articleFeedData') || '{}',
    );

    if (typeof articleFeedData.currentPageNumber === 'number' && articleFeedData.currentPageNumber > 1) {
        return null;
    }

    const getFormattedDate = (date: Date): string => {
        return new Date(date).toLocaleDateString('en-us', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
        });
    };
    const ImageContent = (props: IFeaturedArticleProps) => {
        const imgPath = props.article?.imagePath;
        const imgAlt = props.article?.imageAlt;
        const publishDate = new Date(props.article?.date);

        return (
        <div id='featured-article' className={`flex md:p-0 justify-center ${props.newsVariant ? `${props.bgIsWhite ? 'FeaturedArticle__border' : ''} px-6 bg-white flex-col-reverse` : 'px-12 bg-[#EBF5FF] md:flex-col'}`}>
                <div className={`pt-8 pb-4 md:max-w-full md:pl-4 max-w-[28rem] ${props.newsVariant ? '': 'pr-8'}`}>
                    {(props.article?.date && !props.newsVariant) ?
                        <p className='mb-4'> {publishDate.toDateString()}</p> :
                        <p className='mb-4'> {getFormattedDate(publishDate)} </p>
                    }
                    <TextLine tag='h2' variant="author" authorClass='!text-[1.688rem] !leading-[2.188rem] pb-4'>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.article?.title))}</TextLine>
                    {props.article?.previewDescription && (
                        <TextLine tag='p' variant="author" className='FeaturedArticle__description pb-8'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.article?.previewDescription))}                       
                        </TextLine>)}
                    {(props.ctaButton) && (
                        <Button size='medium' variant='solid'
                            href={props.ctaLink}>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.ctaText))}
                        </Button>
                    )}
                </div>
                {!(props.hideImage && props.newsVariant) &&
                    <div className={`flex justify-center items-center ${props.newsVariant ? 'pt-6 md:px-4': ''}`}>
                            <Image
                                src={imgPath}
                                alt={imgAlt}
                                fetchpriority='high'
                                rel='preload'
                                className={`lg:m-0 md:justify-center ${props.newsVariant ? 'max-w-[25rem] ' : 'max-h-[25rem] '}`}
                            />
                        
                    </div>
                }
            </div>
        );
    };

    return (
        <ImageContent {...props} />
    );
};

export default FeaturedArticle;
